import { render, staticRenderFns } from "./Receive.vue?vue&type=template&id=10c65976&scoped=true&"
import script from "./Receive.vue?vue&type=script&lang=js&"
export * from "./Receive.vue?vue&type=script&lang=js&"
import style0 from "./Receive.vue?vue&type=style&index=0&id=10c65976&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c65976",
  null
  
)

export default component.exports